/*
 *
 * GenericModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 09-Sep-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'

const GenericModal = (props) => (
  <Toggle>
    <MerchantModal
      title={props.title}
      topBarTitle={props.topBarTitle}
      description={props.description}
      customAnalyticsDescription={props.customAnalyticsDescription}
      onClose={props.onClose}
      primaryButtonLabel={props.primaryButtonLabel}
      secondaryButtonLabel={props.secondaryButtonLabel}
      secondaryAction={props.secondaryAction}
      primaryAction={props.primaryAction}
      primaryButtonLoading={props.primaryButtonLoading}
      primaryButtonIcon={props.primaryButtonIcon}
      secondaryButtonLoading={props.secondaryButtonLoading}
      secondaryIcon={props.secondaryIcon}
      primaryIcon={props.primaryIcon}
      disableBackdropClick
    >
      {props.children}
    </MerchantModal>
  </Toggle>
)

GenericModal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  topBarTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  customAnalyticsDescription: PropTypes.string,
  children: PropTypes.node,
  primaryButtonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  primaryButtonIcon: PropTypes.string,
  secondaryButtonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  secondaryAction: PropTypes.func,
  secondaryIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  primaryIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  primaryAction: PropTypes.func,
  primaryButtonLoading: PropTypes.bool,
  secondaryButtonLoading: PropTypes.bool,
  onClose: PropTypes.func
}

GenericModal.defaultProps = {
  title: '',
  topBarTitle: '',
  description: '',
  customAnalyticsDescription: '',
  children: null,
  primaryButtonLabel: '',
  primaryButtonIcon: '',
  secondaryButtonLabel: '',
  secondaryIcon: '',
  primaryIcon: '',
  secondaryAction: () => { },
  primaryAction: () => { },
  informativeText: '',
  primaryButtonLoading: false,
  secondaryButtonLoading: false,
  onClose: undefined
}

export default GenericModal
